/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { useToggle, useTranslate } from "@adapptio/lib-components";

import { FieldLabel } from "@adapptio/lib-editor-ui";
import { TInspectorNode } from "../../InspectorNodeTypes";
import { defaultNodeHintType, getHintComponent } from "../../hints";
import { THintType } from "../../hints/InspectorHintTypes";

export const InspectorNodeLabel: React.FC<{ node: TInspectorNode }> = ({ node }) => {
	const t = useTranslate();
	const label = t("editor", node.label);

	const [ hintOpen, , openHint, closeHint ] = useToggle(false);

	const hint = useMemo(() => {
		const hintType: THintType | null = node.hintType || defaultNodeHintType;

		const Hint = hintType ? getHintComponent(hintType) : undefined;

		if (!Hint) {
			return undefined;
		}

		return <Hint node={node} onClose={closeHint} />;
	}, [ node, closeHint ]);

	return (
		<FieldLabel hint={hint} hintOpen={hintOpen} onHintOpen={openHint} onHintClose={closeHint}>
			{label}
		</FieldLabel>
	);
};
